import BaseModel from '../core/BaseModel'
import moment from "moment";
//import {constants} from "../services/constants";
//import CategoriesModel from './CategoriesModel'
export default class MaintenanceSerialModel extends BaseModel {
    constructor() {
        super({
                name: "maintenance_serial",
                tableName: 'core_maintenance'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                parts_number_info: {
                    name: 'parts_number_info',
                    type: "String",
                    label: 'Đợt bảo trì',
                    class: 'center',
                    sortable: false,
                    width: 8,
                    /*filter: {type: 'input', match: 'custom', placeHolder: 'Nhập số'},*/
                    computed: (data) => {
                        var arr_class_color = {
                            k_0:'class_status_plain',
                            k_1:'class_status_maintenance_needed',
                            k_2:'class_status_processing',
                            k_3:'class_status_for_maintenance',
                            k_4:'class_status_out_of_date',
                            k_5:'class_status_cancel_plan_only',
                        };
                        data.arr_class_color = arr_class_color;
                        data.parts_number_info = (data.parts_number) ? 'Đợt ' + data.parts_number : '';
                        data.customClass = [];
                        data.customClass.push({
                            column:"parts_number_info",
                            class:data.arr_class_color["k_"+data.process_status]
                        })
                    }
                },
                time_between_maintenance_info: {
                    name: 'time_between_maintenance_info',
                    type: "String",
                    label: 'Khoảng thời gian',
                    class: 'center',
                    sortable: false,
                    width: 10,
                    /*filter: {type: 'input', match: 'custom', placeHolder: 'Nhập số'},*/
                    computed: (data) => {
                        data.time_between_maintenance_info = (data.time_between_maintenance) ? data.time_between_maintenance+' tháng' : '';
                        data.customClass.push({
                            column:"time_between_maintenance_info",
                            class:data.arr_class_color["k_"+data.process_status]
                        })
                    }
                },
                date_maintenance_info: {
                    name: 'date_maintenance_info',
                    type: "String",
                    label: 'Tháng bảo trì kế hoạch',
                    width: 15,
                    class: 'center',
                    sortable: false,
                    /*filter: { type: 'DateRange', match: 'custom'},*/
                    computed: (data) => {
                        var timezone = 'Asia/Bangkok';
                        var month_maintenance = moment(data.date_maintenance).tz(timezone).format("MM/YYYY");
                        data.date_maintenance_info = (month_maintenance) ? month_maintenance : '';
                        data.customClass.push({
                            column:"date_maintenance_info",
                            class:data.arr_class_color["k_"+data.process_status]
                        })
                    }
                },
                maintenance_done_date_info: {
                    name: 'maintenance_done_date_info',
                    type: "String",
                    label: 'Ngày bảo trì thực tế',
                    width: 15,
                    class: 'center',
                    sortable: false,
                    /*filter: { type: 'DateRange', match: 'custom'},*/
                    computed: (data) => {
                        var timezone = 'Asia/Bangkok';
                        if (data.maintenance_done_date){
                            var month_maintenance = moment(data.maintenance_done_date).tz(timezone).format("DD/MM/YYYY");
                            data.maintenance_done_date_info = (month_maintenance) ? month_maintenance : ''
                        }else {
                            data.maintenance_done_date_info = '---'
                        }
                        data.customClass.push({
                            column:"maintenance_done_date_info",
                            class:data.arr_class_color["k_"+data.process_status]
                        })
                    }
                },
                /*maintenance_done_date: {
                    name: 'maintenance_done_date',
                    type: "Date",
                    label: 'Ngày bảo trì thự tế',
                    width: 15,
                    sortable: false,
                    /!*filter: {type: 'DateRange', match: 'custom'}*!/
                },*/
                process_status: {
                    name: 'process_status',
                    label: 'Trạng thái bảo trì',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 12,
                    disabled: true,
                    sortable: false,
                    options: [{value: 0, label: 'Kế hoạch', style: 'color: #00CC00; font-weight: 500;'}, {
                        value: 1,
                        label: 'Cần bảo trì',
                        style: 'color: #FF6600; font-weight: 500;'
                    }, {value: 2, label: 'Đang thực hiện', style: 'color: #990099; font-weight: 500;'}, {
                        value: 3,
                        label: 'Đã bảo trì',
                        style: 'color: #0066FF;font-weight: 500;'
                    }, {value: 4, label: 'Quá hạn', style: 'color: #CC0000;font-weight: 500;'}, {
                        value: 5,
                        label: 'Hủy kế hoạch',
                        style: 'color: #666666;font-weight: 500;'
                    }],
                    /*filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},*/
                },
                fied_detail: {
                    refs: 'maintenance_done_date date_maintenance type_maintenance time_between_maintenance serial_user_id parts_number serial_customer list_service_pack_id product_serial_number { id serial_number product { id model_code name } }  ',//obj_customer_user {full_name phone_number obj_customer_profile { id full_name phone_number address province { id name } district { id name } ward { id name }}}
                    display: false
                },
            },)
    }

}